import { useContext } from "react";

import type { BannersData } from "./BannersContext";
import { BannersContext } from "./BannersContext";

const useBanners = (): BannersData => {
  return useContext(BannersContext);
};

export { useBanners };
